<ion-col size="12">
    <ng-container *ngFor="let stripe of stripedata; let i = index">
      <ion-row [ngClass]="evalPadding(i, stripedata.length)">
        <ng-container *ngIf="i % 2 !== 0">
          <ng-container *ngIf="windowRef.width() >= 500">
            <ng-container *ngTemplateOutlet="overviewpicture; context: {imgpadding: '0 16px 0 0'}"></ng-container>
            <ng-container *ngTemplateOutlet="overviewdescription"></ng-container>
          </ng-container>
          <ng-container *ngIf="windowRef.width() < 500">
            <ng-container *ngTemplateOutlet="phonerowoneimgfirst; context: {imgpadding: '0 16px 0 0'}"></ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="i % 2 === 0">
          <ng-container *ngIf="windowRef.width() >= 500">
            <ng-container *ngTemplateOutlet="overviewdescription"></ng-container>
            <ng-container *ngTemplateOutlet="overviewpicture; context:{imgpadding: '0 0 0 16px'}"></ng-container>
          </ng-container>
          <ng-container *ngIf="windowRef.width() < 500">
            <ng-container *ngTemplateOutlet="phonerowoneimglast; context:{imgpadding: '0 0 0 16px'}"></ng-container>
          </ng-container>
        </ng-container>

        <ng-template #overviewpicture let-imgpadding="imgpadding">
          <ion-col size="4" size-sm="6" [ngClass]="{'ion-align-self-center': !stripe.imgcentertop}" [ngStyle]="{'padding': imgpadding}" class="ion-text-center">
              <ng-container *ngIf="stripe.actionbutton && stripe.actionbutton.route">
                  <img [routerLink]="stripe.actionbutton.route" class="href" [ngStyle]="{'border-radius': stripe.roundcorners ? '10px' : '0px', 'max-width': stripe.maxwidth ? stripe.maxwidth : ''}" [src]="stripe.img" [alt]="stripe.description">
              </ng-container>
              <ng-container *ngIf="!stripe.actionbutton || (stripe.actionbutton && !stripe.actionbutton.route)">
                  <img [ngStyle]="{'border-radius': stripe.roundcorners ? '10px' : '0px', 'max-width': stripe.maxwidth ? stripe.maxwidth : ''}" [src]="stripe.img" [alt]="stripe.description">
              </ng-container>
          </ion-col>
        </ng-template>
        <ng-template #overviewdescription>
          <ion-col size="8" size-sm="6" class="ion-text-left">
              <h3 class="ion-padding-bottom overview-title">{{stripe.title}}</h3>
              <p class="overview-desciption" [innerHTML]="stripe.description"></p>
              <div *ngIf="stripe.actionbutton" class="ion-text-center ion-padding bigbutton">
                  <ion-button fill="outline" color="primary" [routerLink]="stripe.actionbutton.route">{{stripe.actionbutton.label}}</ion-button>
              </div>
              <div class="stripe-tags">
                  <ng-container *ngFor="let hash of stripe.hashtags">
                  <span class="tag">#{{hash}}</span>
                  </ng-container>
              </div>
          </ion-col>
        </ng-template>
        <ng-template #phonerowoneimglast let-imgpadding="imgpadding">
          <ion-col size="12">
            <ion-row>
              <ion-col size="8">
                <h3 class="ion-padding-bottom overview-title">{{stripe.title}}</h3>
              </ion-col>
              <ion-col size="4" [ngStyle]="{'padding': imgpadding}">
                  <ng-container *ngIf="stripe.actionbutton && stripe.actionbutton.route">
                      <img [routerLink]="stripe.actionbutton.route" class="href" [ngStyle]="{'border-radius': stripe.roundcorners ? '10px' : '0px'}" [src]="stripe.img" [alt]="stripe.description">
                  </ng-container>
                  <ng-container *ngIf="!stripe.actionbutton || (stripe.actionbutton && !stripe.actionbutton.route)">
                      <img [ngStyle]="{'border-radius': stripe.roundcorners ? '10px' : '0px'}" [src]="stripe.img" [alt]="stripe.description">
                  </ng-container>            
              </ion-col>
              <ion-col size="12">
                <p class="overview-desciption" [innerHTML]="stripe.description"></p>
                <div class="stripe-tags" *ngIf="stripe.hashtags">
                  <ng-container *ngFor="let hash of stripe.hashtags">
                    <span class="tag">#{{hash}}</span>
                  </ng-container>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>              
        </ng-template>
        <ng-template #phonerowoneimgfirst let-imgpadding="imgpadding">
          <ion-col size="12">
            <ion-row>
              <ion-col size="4" [ngStyle]="{'padding': imgpadding}">
                <img [ngStyle]="{'border-radius': stripe.roundcorners ? '10px' : '0px'}" [src]="stripe.img" [alt]="stripe.description">
              </ion-col>
              <ion-col size="8">
                <h3 class="ion-padding-bottom overview-title">{{stripe.title}}</h3>
              </ion-col>
              <ion-col size="12">
                <p class="overview-desciption" [innerHTML]="stripe.description"></p>
                <div *ngIf="stripe.actionbutton" class="ion-text-center ion-padding-top">
                  <ion-button fill="outline" color="primary" [routerLink]="stripe.actionbutton.route">{{stripe.actionbutton.label}}</ion-button>
                </div>
                <div class="stripe-tags" *ngIf="stripe.hashtags">
                  <ng-container *ngFor="let hash of stripe.hashtags">
                    <span class="tag">#{{hash}}</span>
                  </ng-container>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
        </ng-template>
        <ng-template #phonerowtwo>
          <ion-col size="4" size-sm="6"><img [ngStyle]="{'border-radius': stripe.roundcorners ? '10px' : '0px'}" [src]="stripe.img" [alt]="stripe.description"></ion-col>
        </ng-template>
      </ion-row>
    </ng-container>
  </ion-col>